import React, { useEffect } from "react";

// Popup callback for Facebook OAuth: relays the code back to the opener window.
export default function FacebookCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payload = {
      type: "facebook_oauth_response",
      code: params.get("code"),
      state: params.get("state"),
      error: params.get("error") || params.get("error_reason"),
    };
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(payload, window.location.origin);
    }
    window.close();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center font-nunito text-[#0B1D3A]">
      A concluir o início de sessão...
    </div>
  );
}
